import { em } from 'polished'
import styled, { css } from 'styled-components'

import DynamicImage from 'components/DynamicImage'

const height = em(83)
const heightMd = em(400)

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: ${height};
  transform: translateX(${em(20)});

  ${p => p.theme.mq.upMd} {
    height: ${heightMd};
    transform: translateY(${em(40)});
  }
`

const behaviourMd = css`
  left: 50%;
  width: auto;
  height: 140%;
  transform: translateX(-50%);
`

export const DynamicImageStyled = styled(DynamicImage)`
  position: absolute;
  right: 0;
  bottom: 0;
  width: ${height};
  height: auto;
  transform-origin: 0 100%;
  transform: translateX(100%) rotate(-90deg);

  ${p => p.theme.mq.upMd} {
    right: auto;
    ${behaviourMd};
  }
`

export const Line = styled.div`
  display: none;

  ${p => p.theme.mq.upLg} {
    display: block;
    position: absolute;
    bottom: 0;
    ${behaviourMd};
  }

  svg {
    overflow: visible !important;
  }
`
